import { render, staticRenderFns } from "./CompanyProgramLogo.vue?vue&type=template&id=6dac2d45"
import script from "./CompanyProgramLogo.vue?vue&type=script&lang=js"
export * from "./CompanyProgramLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports